module.exports = __webpack_public_path__ + "img/micronesia.853a539a.svg";